import { DateRangeStep as SharedDateRangeStep } from "../../shared/DateRangeStep";
import { isSectionBindable } from "../../../Processing/controllerBindings";
import type { GraphFormState } from "../plotState";

interface DateRangeStepProps {
  graph: GraphFormState;
  graphIndex: number;
  onChange: (patch: Partial<GraphFormState>) => void;
}

export function DateRangeStep({ graph, graphIndex, onChange }: DateRangeStepProps) {
  return (
    <SharedDateRangeStep
      value={graph}
      onChange={onChange}
      itemIndex={graphIndex}
      inheritLabel="Same as Plot 1"
      description="Set the time window for this plot's data."
      bindable={isSectionBindable("chart", "date")}
      allowLatestN
    />
  );
}
